import { Injectable, inject } from '@angular/core'
import { Filter, Page, Pageable, RestClientPaged } from '@elderbyte/ngx-starter'
import { HttpClient, HttpParams } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { Material } from './material'
import { Observable } from 'rxjs'

export class MaterialFilter {
  public static types(types: string[]): Filter {
    return new Filter('types', types)
  }
}

@Injectable({
  providedIn: 'root',
})
export class MaterialService extends RestClientPaged<Material, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/materials', http, {
      idField: 'id',
      idsParam: 'ids',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public getAllPaged(
    pageable: Pageable,
    filters: Filter[] = [],
    archived: boolean = false
  ): Observable<Page<Material>> {
    filters.push(new Filter('archived', String(archived)))
    return this.findAllPaged(pageable, filters)
  }

  public findByIdArchived(materialNumber: string, archived: boolean = false): Observable<Material> {
    const params = new HttpParams().set('archived', String(archived))
    return this.findById(materialNumber, params)
  }

  public findByIdOrSearchTerm(searchTermOrId: string): Observable<Page<Material>> {
    return this.findAllPaged(new Pageable(0, 1), [
      new Filter('fullMatchOnCodeOrId', searchTermOrId),
    ])
  }
}
